var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1664",
    "data-name": "Caminho 1664",
    d: "M24,48h0A24,24,0,0,0,48,24h0A24,24,0,0,0,24,0h0A24,24,0,0,0,0,24H0A24,24,0,0,0,24,48Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1665",
    "data-name": "Caminho 1665",
    d: "M18,25.442v13.59a1.291,1.291,0,0,0,1.287,1.339H40.5a1.3,1.3,0,0,0,1.287-1.339V25.442A1.306,1.306,0,0,0,40.5,24H19.287A1.3,1.3,0,0,0,18,25.442m1.956,1.184a.473.473,0,0,1,.515-.515c.2,0,7.9,4.884,8.37,5.17l1.206.75c.382-.256.766-.475,1.163-.741.809-.517,8.008-5.179,8.206-5.179a.473.473,0,0,1,.515.515c0,.347-.668.691-1.1.957-2.734,1.666-5.467,3.482-8.173,5.21-.158.107-.464.335-.693.3-.256-.04-8.1-5.078-9.525-5.917-.214-.126-.48-.242-.48-.55",
    transform: "translate(-6 -8)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.aade8d0050a5711e51cdcabe3d95f863.svg";
export { ForwardRef as ReactComponent };